import { createApi } from "@reduxjs/toolkit/query/react";

import {
  baseQuery,
  ADD_DOCUMENT,
  DELETE_DOCUMENT,
  GET_ALL_DOCUMENTS,
} from "@/graphql";

export const documentApi = createApi({
  reducerPath: "api/document",
  tagTypes: ["Documents"],
  baseQuery,
  endpoints: (builder) => ({
    getAllDocuments: builder.query<
      DocumentsReponse["documents"],
      {
        pageNo?: number;
        pageSize?: number;
        searchKeyword?: string;
        clientId?: string;
        tenantId?: string;
      }
    >({
      query: (variables) => ({
        document: GET_ALL_DOCUMENTS,
        variables: { ...variables },
      }),
      transformResponse: (response: DocumentsReponse) => {
        return response.documents;
      },
      providesTags: ["Documents"],
    }),
    postDocument: builder.mutation<string, DocumentsDto>({
      query: (variables) => ({
        document: ADD_DOCUMENT,
        variables: { ...variables },
      }),
      transformResponse: (response: CreateDocumentReponse) => {
        return response.createDocument.data;
      },
      invalidatesTags: ["Documents"],
    }),
    deleteDocuments: builder.mutation<boolean, string>({
      query: (id) => ({
        document: DELETE_DOCUMENT,
        variables: { id },
      }),
      transformResponse: (response: DeleteDocumentReponse) => {
        return response.deleteDocument.data;
      },
      invalidatesTags: ["Documents"],
    }),
  }),
});

export const {
  useGetAllDocumentsQuery,
  usePostDocumentMutation,
  useDeleteDocumentsMutation,
} = documentApi;
